module.exports = __webpack_public_path__ + "media/images/bg-frage-1622df47798c9646923faa8f2584393c.png";